import React from 'react';
import {
	AGENCY_PROJECT,
	CSV_TYPES,
	PROJECT_ASG,
	PROJECT_BSG,
	PROJECT_CAR,
	PROJECT_CAR2,
	PROJECT_CCC,
	PROJECT_CCG,
	PROJECT_CGL,
	PROJECT_CGR,
	PROJECT_CRI,
	PROJECT_CSV,
	PROJECT_CVC,
	PROJECT_DOG,
	PROJECT_EUG,
	PROJECT_GRA,
	PROJECT_HGG,
	PROJECT_ING,
	PROJECT_LTG,
	PROJECT_NSG,
	PROJECT_STS,
	PROJECT_UGG,
	SUB_AGENCY_PROJECT
} from './utils/Constants';

export default function useFilters(_refreshSearch) {
	const [filters, _setFilters] = React.useState({
		[AGENCY_PROJECT]: [
			{
				key: AGENCY_PROJECT,
				value: true,
				label: 'Agenzie',
				resultsNumber: 0,
				icon: 'pin/pin_agenzie.png'
			},
			{
				key: SUB_AGENCY_PROJECT,
				value: true,
				label: 'Subagenzie',
				resultsNumber: 0,
				icon: 'pin/pin_subagenzie.png'
			}
		],
		[PROJECT_CAR2]: [
			{
				key: 'Network Axa',
				value: true,
				label: 'Network Axa',
				resultsNumber: 0,
				icon: 'pin/pin_yellow.png'
			},
			{
				key: 'Soluzione Carrozzerie',
				value: true,
				label: 'Carsafe',
				resultsNumber: 0,
				icon: 'pin/pin_red.png'
			},
			{
				key: 'Carclinic',
				value: true,
				label: 'Carclinic',
				resultsNumber: 0,
				icon: 'pin/pin_blue.png'
			},
			{
				key: 'METAFORA',
				value: true,
				label: 'Metafora',
				resultsNumber: 0,
				icon: 'pin/pin_brown.png'
			},
			{
				key: 'autosicura',
				value: true,
				label: 'Autosicura',
				resultsNumber: 0,
				icon: 'pin/pin_autosicura.png'
			},
			{
				key: 'RIPARTE',
				value: true,
				label: 'Riparte',
				resultsNumber: 0,
				icon: 'pin/pin_riparte.png'
			}
		],
		[PROJECT_CRI]: [
			{
				key: PROJECT_CCG,
				value: true,
				label: PROJECT_CCG,
				resultsNumber: 0,
				icon: 'pin/pin_carglass.png'
			},
			{
				key: PROJECT_CGL,
				value: true,
				label: PROJECT_CGL,
				resultsNumber: 0,
				icon: 'pin/pin_glassdrive.png'
			},
			{
				key: PROJECT_CVC,
				value: true,
				label: PROJECT_CVC,
				resultsNumber: 0,
				icon: 'pin/pin_vetrocar.png'
			}
		],
		[PROJECT_GRA]: [
			{
				key: PROJECT_CCC,
				value: true,
				label: 'Clinic Grandine',
				resultsNumber: 0,
				icon: 'pin/pin_carclinic.png'
			},
			{
				key: PROJECT_CGR,
				value: true,
				label: 'Maestri della grandine',
				resultsNumber: 0,
				icon: 'pin/pin_maestri.png'
			},
			{
				key: PROJECT_DOG,
				value: true,
				label: 'Dottor Grandine',
				resultsNumber: 0,
				icon: 'pin/pin_dottor_grandine.png'
			},
			{
				key: PROJECT_BSG,
				value: true,
				label: 'Ballsystem',
				resultsNumber: 0,
				icon: 'pin/pin_ballsystem.png'
			},
			{
				key: PROJECT_LTG,
				value: true,
				label: 'LeverTouch',
				resultsNumber: 0,
				icon: 'pin/pin_levertouch.png'
			},
			{
				key: PROJECT_EUG,
				value: true,
				label: 'Eurograndine',
				resultsNumber: 0,
				icon: 'pin/pin_eurograndine.png'
			},
			{
				key: PROJECT_HGG,
				value: true,
				label: 'HailGuard',
				resultsNumber: 0,
				icon: 'pin/pin_hailguard.png'
			},
			{
				key: PROJECT_UGG,
				value: true,
				label: 'UpGrandine',
				resultsNumber: 0,
				icon: 'pin/pin_upgrandine.png'
			},
			{
				key: PROJECT_ASG,
				value: true,
				label: 'Autosicura',
				resultsNumber: 0,
				icon: 'pin/pin_autosicura.png'
			},
			{
				key: PROJECT_ING,
				value: true,
				label: 'Inova',
				resultsNumber: 0,
				icon: 'pin/pin_inova.png'
			},
			{
				key: PROJECT_NSG,
				value: true,
				label: 'Non Solo Grandine',
				resultsNumber: 0,
				icon: 'pin/pin_nonsolograndine.png' // TODO: attivare
			},
			{
				key: PROJECT_STS,
				value: true,
				label: 'Storm Solution',
				resultsNumber: 0,
				icon: 'pin/pin_stormsolution.png' // TODO: attivare
			}
		],
		[PROJECT_CSV]: [
			{
				key: CSV_TYPES.caseDiCura.class,
				value: true,
				label: CSV_TYPES.caseDiCura.label,
				resultsNumber: 0,
				icon: 'pin/pin_protezione_salute.png'
			},
			{
				key: CSV_TYPES.centriSpecialistici.class,
				value: true,
				label: CSV_TYPES.centriSpecialistici.label,
				resultsNumber: 0,
				icon: 'pin/pin_specialistici_convenzionati.png'
			},
			{
				key: CSV_TYPES.centriOdontoiatrici.class,
				value: true,
				label: CSV_TYPES.centriOdontoiatrici.label,
				resultsNumber: 0,
				icon: 'pin/pin_odontoiatria.png'
			},
			{
				key: CSV_TYPES.ospedali.class,
				value: true,
				label: CSV_TYPES.ospedali.label,
				resultsNumber: 0,
				icon: 'pin/pin_semplicemente_vita.png'
			}
		]
	});

	function setFilters(filters, refreshSearch) {
		_setFilters(filters);

		if (refreshSearch) _refreshSearch();
	}

	return [filters, setFilters];
}
